import type { ReactNode } from "react";
import Breadcrumbs, { type Crumb } from "@/components/feature/Breadcrumbs";

interface PageHeaderProps {
  title: string;
  description: string;
  crumbs: Crumb[];
  eyebrow?: string;
  children?: ReactNode;
}

export default function PageHeader({ title, description, crumbs, eyebrow, children }: PageHeaderProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="paper-grid">
        <div className="mx-auto max-w-content px-4 py-10 md:px-6 md:py-14">
          <Breadcrumbs items={crumbs} />
          {eyebrow && (
            <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
              <span className="flex h-4 w-4 items-center justify-center"><i className="ri-bookmark-line" /></span>
              {eyebrow}
            </p>
          )}
          <h1 className="mt-4 max-w-3xl font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
            {title}
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
          {children}
        </div>
      </div>
    </section>
  );
}